import { render } from "./LayerChat.vue?vue&type=template&id=0d809d54&scoped=true"
import script from "./LayerChat.vue?vue&type=script&lang=js"
export * from "./LayerChat.vue?vue&type=script&lang=js"

import "./LayerChat.vue?vue&type=style&index=0&id=0d809d54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d809d54"]])

export default __exports__